import React, { Component } from "react";
import PropTypes from "prop-types";
import noop from "lodash/noop";
import styled from "styled-components";

export const client = "ca-pub-3862745611943470";

const Insert = styled.ins`
  min-height: 160px !important;
`;

export class ResponsiveAd extends Component {
  componentDidMount() {
    if (window) (window.adsbygoogle = window.adsbygoogle || []).push({});
  }

  render() {
    return (
      <Insert
        className="adsbygoogle"
        style={{ ...this.props.style, display: "block" }}
        data-ad-client={client}
        data-ad-slot="4802662245"
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ui/ads.js